import React from 'react'

// Pill-style toggles shown on the search results page next to the result
// count. Disabled pills (light gray) hide their category from the results
// list. Category keys match the `enabledCategories` state in
// SearchResultsContainer.
const FILTERS = [
  { key: 'repos', label: 'Packs' },
  { key: 'folders', label: 'Folders' },
  { key: 'setsQuestions', label: 'Content Items' },
]

function CategoryFilters({ enabled, onToggle }) {
  if (!enabled || !onToggle) return null
  return (
    <div className='searchResults-categoryFilters'>
      {FILTERS.map(({ key, label }) => {
        const isOn = !!enabled[key]
        const modifier = isOn ? '--on' : '--off'
        return (
          <button
            key={key}
            type='button'
            className={`searchResults-categoryFilters-pill searchResults-categoryFilters-pill${modifier}`}
            onClick={() => onToggle(key)}
            aria-pressed={isOn}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}

export default CategoryFilters
